import RecoverStep from "./recover_step";
import {showVmsList} from "../utils/recover_utils";

const TEMPLATE = 'notavailable';

export default class NotAvailable extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    transitionViewService(data, el, fr) {
        showVmsList(data);
    }

    transitionBack(data, el, fr) {
        fr.goTo(data.tmp.previousStep);
    }

}
